import * as types from '../mutation-types';

// state
export const state = {
  visible: false,
  mini: false,
  count_notify: 0,
};

// getters
export const getters = {
  visible: (state) => state.visible,
  mini: (state) => state.mini,
  count_notify: (state) => state.count_notify,
};

// mutations
export const mutations = {
  [types.SET_SIDEBAR_VISIBLE](state, { value }) {
    state.visible = value;
  },
  [types.SET_SIDEBAR_MINI](state, { value }) {
    state.mini = value;
  },
  [types.SET_COUNT_NOTIFY](state, { value }) {
    state.count_notify = value;
  },
  [types.MINUS_COUNT_NOTIFY](state) {
    state.count_notify--;
  },
};

// actions
export const actions = {
  setSidebarVisible({ commit }, { value }) {
    commit(types.SET_SIDEBAR_VISIBLE, { value });
  },
  setSidebarMini({ commit }, { value }) {
    commit(types.SET_SIDEBAR_MINI, { value });
  },
  setSidebarCountNotify({ commit }, { value }) {
    commit(types.SET_COUNT_NOTIFY, { value });
  },
  minusSidebarCountNotify({ commit }) {
    commit(types.MINUS_COUNT_NOTIFY);
  },

};
